import React, { useEffect, useState } from 'react'
import { Box } from '@chilipiper/design-system'
import { AlertBanner } from '@chilipiper/design-system/src/new'
import { useMutation } from '@tanstack/react-query'
import { T, useLocale } from '@chilipiper/locale/src/new'
import { format } from '@chilipiper/date-time'
import { useTimeoutContext } from '../../../chat-widget/TimeoutContext'
import { useMessageFeedContext } from '../../../chat-widget/MessageFeedContext'
import { useTranslations } from '../../../context/TranslationContext'

export const Timeout = ({ timeout = Infinity }: { timeout: number | undefined }) => {
  const [isDismissed, setIsDismissed] = useState(false)
  const { timeLeft, enableTimeout } = useTimeoutContext()
  const { triggerMeetingFallback } = useMessageFeedContext()
  const locale = useLocale()
  const [meetingTimeout] = useTranslations(['meetingTimeout'])
  const { mutate: triggerFallback } = useMutation({
    mutationFn: async () => {
      triggerMeetingFallback()
    },
  })

  useEffect(() => {
    enableTimeout(timeout, triggerFallback)
  }, [timeout])

  if (timeLeft > 60 * 1000) {
    return null
  }

  const timeLeftInSeconds = Math.ceil(timeLeft / 1000)
  const timeLeftAsText = format(new Date(timeLeft), timeLeftInSeconds === 60 ? 'm' : 's', {
    locale,
  })

  const handleClose = () => {
    setIsDismissed(true)
  }

  if (isDismissed) {
    return null
  }

  return (
    <Box
      left={0}
      top={11}
      right={0}
      zIndex={10}
      bg='bg/page'
      display='flex'
      position='absolute'
      alignItems='center'
      justifyContent='center'
    >
      <AlertBanner
        isDismissable={true}
        onClose={handleClose}
        title={
          (
            <T data={{ timeLeft: timeLeftAsText }}>
              {meetingTimeout ?? '{timeLeft} seconds left to confirm your meeting.'}
            </T>
          ) as unknown as string
        }
        variant='inform'
      />
    </Box>
  )
}
